import { start_channels_search } from './parts/other-functions';
import { start_cities_search } from './parts/other-functions';
import { show_modal } from './parts/geo-location';
import { cookie_has_city } from './parts/geo-location';
import { get_location } from './parts/geo-location';
import { set_city_in_cookie } from './parts/geo-location';
import { scroll_to } from './parts/other-functions';
import { show_choose_city_popup } from './parts/other-functions';
import { header_main_start } from './header/header';
import {
    handleClickAddProductCart,
    handleClickProductChangeQuantity,
    handleClickRemoveProductCart,
    notices_remove,
    updateCart
} from './parts/wc.js';

jQuery(function ($) {
    start_channels_search();
    start_cities_search();
    show_modal();
    notices_remove();

    if (!cookie_has_city()) {
        get_location();
    }

    $(document.body).on('click', '[data-set-city-in-cookie]', set_city_in_cookie);
    $(document.body).on('click', '.link-to', scroll_to);
    $(document.body).on('click', '[data-more-cities]', show_choose_city_popup);
    $(document.body).on(
        'click',
        '[data-product] [data-add-product-cart], [data-product]:not(.in_cart) [data-product-change-cart]',
        handleClickAddProductCart
    );
    $(document.body).on('click', '[data-product].in_cart [data-product-change-cart]', handleClickRemoveProductCart);
    $(document.body).on('click', '[data-quantity=minus], [data-quantity=plus]', handleClickProductChangeQuantity);
    $(document.body).on('change', '[data-quantity] .qty', updateCart);
});

header_main_start();
